import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationPaymentRequestTemplates = [
  {
    id: '-217001',
    language: Language.EN,
    subject: 'Invitation to pay a service or an exceptional charge',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>An amount of {{totalAmount}} € remains unpaid for a service charge.</p>
          <p>All details here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-217002',
    language: Language.FR,
    subject: 'Invitation à payer un frais de service ou une charge exceptionnelle',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Le montant de {{totalAmount}} € demeure impayé pour un frais de service.</p>
          <p>Plus de détails ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-217003',
    language: Language.NL,
    subject: 'Einladung zur Zahlung einer Servicegebühr oder einer außergewöhnlichen Abgabe',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Een bedrag van {{totalAmount}} € blijft onbetaald voor de dienstvergoeding.</p>
          <p>Meer details hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-217004',
    language: Language.DE,
    subject: 'Einladung zur Zahlung einer Servicegebühr',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ein Betrag von {{totalAmount}} € bleibt für eine Servicegebühr unbezahlt.</p>
          <p>Alle Details hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
